var locale = {
  placeholder: '請選擇時間'
};
export default locale;
//# sourceMappingURL=zh_TW.js.map
